import { useLocationResourceStore } from './useLocationResourceStore'

/** Store-backed Location Resource records and save command. */
export default function useLocationResources({
  projectId,
}: {
  projectId?: string
}) {
  const { records, loading, isReady, schema, save, store } =
    useLocationResourceStore(projectId)

  return {
    records,
    loading,
    isReady,
    schema,
    save,
    controlCommands: store.controls,
  }
}
